import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import { NavItem } from 'reactstrap'
import PropTypes from 'prop-types'

AdminNavBarItem.propTypes = {
  endpoint: PropTypes.string.isRequired,
  icon: PropTypes.string,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
}

export default function AdminNavBarItem(props) {
  return (
    <React.Fragment>
      <NavItem key={'navitem-' + props.id}>
        <NavLink
          className="nav-link"
          key={'navlink-' + props.id}
          to={props.endpoint}
        >
          {props.icon && <i className={props.icon} />}
          &nbsp;{props.name}
        </NavLink>
      </NavItem>
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/components/AdminNavBarItem/AdminNavBarItem.js